"use client";

import React, { useState } from "react";
import toast from "react-hot-toast";
import { UserAuth } from "../../context/authContext";
import PublicLayout from "../layout/PublicLayout";

const Login = () => {
  const [email, setEmail] = useState("");
  const [loginEmail, setloginEmail] = useState("");
  const [loginPassword, setloginPassword] = useState("");
  const [showlogin, setshowlogin] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { signUp, signIn } = UserAuth();
  const user = UserAuth();

  React.useEffect(() => {
    if (user.email) {
      window.location.href = "/";
    }
  }, [user.email]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!loginEmail || !loginPassword) {
      setError("Email and password are required");
      toast.error("Email and password are required");
      return;
    }

    try {
      await signIn(loginEmail, loginPassword);
      toast.success("Logged in successfully");
      window.location.href = "/";
    } catch (error) {
      toast.error("Error: " + error);
      setError(error.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("All fields are required");
      toast.error("All fields are required");
      return;
    }

    try {
      await signUp(email, password);
      toast.success("Account created successfully");
      window.location.href = "/";
    } catch (error) {
      setError(error.message);
      toast.error(error.message);
    }
  };

  return (
    <PublicLayout>
      <div className="min-h-screen bg-gradient-to-br from-[#4916CF] via-[#250B69] to-[#0a0015] flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            {!showlogin ? (
              <div>
                {/* Sign In Form */}
                <h2 className="text-3xl md:text-4xl font-bold text-center text-[#000000] mb-2">
                  Sign In
                </h2>
                <p className="text-center text-gray-600 text-sm mb-8">
                  Your Trusted Gateway to Learning Blockchain
                </p>

                {error && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-600 text-sm">{error}</p>
                  </div>
                )}

                <form className="space-y-4">
                  <div>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={loginEmail}
                      onChange={(e) => setloginEmail(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-[#4916CF] focus:ring-2 focus:ring-[#4916CF]/20 transition bg-white text-black"
                    />
                  </div>

                  <div>
                    <input
                      type="password"
                      placeholder="Enter your password"
                      value={loginPassword}
                      onChange={(e) => setloginPassword(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-[#4916CF] focus:ring-2 focus:ring-[#4916CF]/20 transition bg-white text-black"
                    />
                  </div>

                  <button
                    onClick={handleLogin}
                    type="button"
                    className="w-full bg-gradient-to-r from-[#4916CF] to-[#250B69] text-white font-semibold py-3 rounded-lg hover:from-[#3a0fa8] hover:to-[#1a0a4f] transition duration-200 mt-6"
                  >
                    Sign In
                  </button>
                </form>

                <div className="mt-6 text-center">
                  <p className="text-gray-600 text-sm">
                    Don't have an account?{" "}
                    <button
                      onClick={() => {
                        setshowlogin(true);
                        setError("");
                      }}
                      className="text-[#4916CF] font-semibold hover:underline cursor-pointer"
                    >
                      Sign Up
                    </button>
                  </p>
                </div>
              </div>
            ) : (
              <div>
                {/* Sign Up Form */}
                <h2 className="text-3xl md:text-4xl font-bold text-center text-[#000000] mb-2">
                  Sign Up
                </h2>
                <p className="text-center text-gray-600 text-sm mb-8">
                  Your Trusted Gateway to Learning Blockchain
                </p>

                {error && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-600 text-sm">{error}</p>
                  </div>
                )}

                <form className="space-y-4">
                  <div>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-[#4916CF] focus:ring-2 focus:ring-[#4916CF]/20 transition  bg-white text-black"
                    />
                  </div>

                  <div>
                    <input
                      type="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-[#4916CF] focus:ring-2 focus:ring-[#4916CF]/20 transition bg-white text-black"
                    />
                  </div>

                  <button
                    onClick={handleSignUp}
                    type="button"
                    className="w-full bg-gradient-to-r from-[#4916CF] to-[#250B69] text-white font-semibold py-3 rounded-lg hover:from-[#3a0fa8] hover:to-[#1a0a4f] transition duration-200 mt-6"
                  >
                    Sign Up
                  </button>
                </form>

                <div className="mt-6 text-center">
                  <p className="text-gray-600 text-sm">
                    Already have an account?{" "}
                    <button
                      onClick={() => {
                        setshowlogin(false);
                        setError("");
                      }}
                      className="text-[#4916CF] font-semibold hover:underline cursor-pointer"
                    >
                      Sign In
                    </button>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Login;
